import { memo } from 'react';

import { Skeleton } from '@/components/ui/skeleton';

/**
 * IntegrationItemSkeleton - Loading skeleton for integration items
 *
 * Displays a placeholder skeleton that matches the layout of IntegrationItem
 * while data is being fetched.
 *
 * @returns {JSX.Element} The integration item skeleton component
 */
const IntegrationItemSkeleton = memo(() => {
  return (
    <div className="flex w-full items-center gap-4 rounded-lg border border-stroke bg-background px-4 py-4">
      <Skeleton className="h-12 w-12 shrink-0 rounded" />
      <div className="flex flex-1 flex-col justify-center gap-1">
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-3 w-24" />
      </div>
      <Skeleton className="h-6 w-6 rounded" />
    </div>
  );
});

IntegrationItemSkeleton.displayName = 'IntegrationItemSkeleton';

export default IntegrationItemSkeleton;
